import classNames from "classnames";
import { faArrowUp } from "@fortawesome/pro-solid-svg-icons";
import { Alert } from "@growtherapy/sprout-ui";

export type JoinWaitingRoomReminderProps = {
  className?: string;
  show?: boolean;
};

export function JoinWaitingRoomReminder({
  className,
  show = true,
}: JoinWaitingRoomReminderProps) {
  return (
    <Alert
      className={
        // consider @starting-style to animate the reveal
        // https://caniuse.com/mdn-css_at-rules_starting-style
        classNames({ hidden: !show }, "text-sm", className)
      }
      icon={faArrowUp}
      use="warning"
    >
      To join the waiting room, enter your name
      <span className="sr-only">&nbsp;above,</span> & press “Continue.”
    </Alert>
  );
}
